// Reusable skeleton placeholders. Use these instead of spinners when the
// final UI is a predictable shape (list, table, card) — the layout doesn't
// jump when data arrives.

const baseClass = "animate-pulse bg-slate-200 rounded";

export function SkeletonLine({ width = "100%", height = 14, className = "" }) {
  return (
    <div
      className={`${baseClass} ${className}`}
      style={{ width, height }}
    />
  );
}

export function SkeletonCircle({ size = 40, className = "" }) {
  return (
    <div
      className={`animate-pulse bg-slate-200 rounded-full ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

// List-item shape: avatar circle + 2 lines (title + subtitle).
export function SkeletonListItem({ className = "" }) {
  return (
    <div
      className={`flex items-center gap-3 px-4 py-3 ${className}`}
    >
      <SkeletonCircle size={36} />
      <div className="flex-1 space-y-2">
        <SkeletonLine width="40%" height={12} />
        <SkeletonLine width="70%" height={10} />
      </div>
    </div>
  );
}

// Card shape: thumbnail + title + meta + body lines.
export function SkeletonCard({ className = "" }) {
  return (
    <div
      className={`bg-white rounded-lg border border-slate-200 p-4 ${className}`}
    >
      <div className="flex items-center gap-3 mb-3">
        <SkeletonCircle size={40} />
        <div className="flex-1 space-y-2">
          <SkeletonLine width="35%" height={12} />
          <SkeletonLine width="20%" height={10} />
        </div>
      </div>
      <div className="space-y-2">
        <SkeletonLine width="100%" height={10} />
        <SkeletonLine width="90%" height={10} />
        <SkeletonLine width="60%" height={10} />
      </div>
    </div>
  );
}

// Table-row shape: configurable column count.
export function SkeletonRow({ cols = 4, className = "" }) {
  return (
    <tr className={`border-b border-slate-100 ${className}`}>
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="px-4 py-3">
          <SkeletonLine width={i === 0 ? "60%" : "40%"} />
        </td>
      ))}
    </tr>
  );
}
